import styled from 'styled-components';
import { TextareaAutosize } from '@mui/material';
import { ShadowDivider } from '@shared/styledComponents';
import { colorTheme } from '@styles/muiTheme';

export const DealCalculatorWrapper = styled.div`
  position: relative;
  display: inline-flex;
  padding: 10px 20px;
  width: 100%;
  min-height: 113px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  flex: 1;
`;

export const Row = styled.div<{ white?: boolean }>`
  display: flex;
  align-items: center;
  white-space: nowrap;
  padding: 8px;
  height: 30px;
  color: ${({ white }) => (white ? 'auto' : `${colorTheme.palette.common.black}`)};
  background: ${({ white }) => (white ? `${colorTheme.palette.secondary.light}` : `${colorTheme.palette.grey[500]}`)};
`;

export const NotesSection = styled.div`
  flex: 1;
  display: flex;
  padding-left: 15px;
  flex-direction: column;
`;

export const Label = styled.div`
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Notes = styled(TextareaAutosize)`
  display: flex;
  border: 1px solid ${colorTheme.palette.grey[500]};
  border-radius: 4px;
  padding: 15px;
  resize: none;
  flex: 1;
`;

export const ButtonsSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-left: 15px;
  gap: 5px;

  button {
    height: 30px;
    line-height: 1.3;
  }
`;

export const Table = styled.div`
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  width: 100%;
  gap: 1px;
  flex: 4;
`;

export const Divider = styled(ShadowDivider)`
  position: absolute;
  left: 0;
  top: -30px;
`;

export const Header = styled.div`
  color: ${colorTheme.palette.common.white};
  font-size: 14px;
  padding: 16px 20px;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.primary.dark};
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;

  b {
    display: block;
    font-weight: 700;
    margin-bottom: 10px;
  }
`;

export const Cell = styled.div``;